export const ADDRESS_SET_TO_DEFAULT = 'address_set_to_default';
export const ADDRESS_DELETED = 'address_deleted';
export const USER_LOGOUT = 'user_logout';
export const TRADE_INITIATED = 'trade_initiated';
export const TRADE_EXECUTED = 'trade_executed';
export const DEPOSIT_INITIAITED = 'deposit_initiated';
export const DEPOSIT = 'deposit';
export const AIP_UPDATED = 'aip_updated';
export const AIP_ENABLED = 'aip_enabled';
export const DELIVERY_EXECUTED = 'delivery_executed';
export const PASSWORD_CHANGED = 'password_changed';
export const SECURITY_QUESTION_CHANGED = 'security_question_changed';
export const FULL_NAME_EDITED = 'full_name_edited';
export const WITHDRAW_INITIATED = 'withdraw_initiated';
export const WITHDRAW = 'withdraw';
export const AIP_RESTARTED = 'aip_restarted';
export const AIP_DISABLED = 'aip_disabled';
export const USER_LOGIN = 'login';
export const DELIVERY_INITIATED = 'delivery_initiated';
export const PURCHASE = 'purchase';
export const ADD_TO_CART = 'add_to_cart';
export const APPLICATION_STARTED = 'application_started';
export const VIEW_ITEM = 'view_item';
export const SELECT_ITEM = 'select_item';
export const ACCOUNT_DATA_LOADED = 'account_data_loaded';
export const BANK_ACCOUNT_ADDED = 'app.bank_account_added';
export const BANK_ACCOUNT_REMOVED = 'app.bank_account_removed';
export const FUND_DEPOSIT_START = 'app.fund_deposit_start';
export const FUND_DEPOSIT_COMPLETE = 'app.fund_deposit_complete';
export const FUND_WITHDRAW_START = 'app.fund_withdraw_start';
export const FUND_WITHDRAW_COMPLETE = 'app.fund_withdraw_complete';
export const APPLICATION_TERMS_VIEWED = 'funnel.application_terms_viewed';
export const APPLICATION_TERMS_ACCEPTED = 'funnel.application_terms_accepted';

// Sell From Home (SFH) events
export const SFH_CTA_PORTFOLIO_CLICKED = 'sfh_cta_portfolio_clicked';
export const SFH_CTA_SELL_CLICKED = 'sfh_cta_sell_clicked';
export const SFH_CTA_SFS_WIZARD_CLICKED = 'sfh_cta_sfs_wizard_clicked';
export const SFH_TOP_BACK_CLICKED = 'sfh_top_back_clicked';
export const SFH_TOP_CLOSE_CLICKED = 'sfh_top_close_clicked';
export const SFH_METAL_TYPE_FILTER_CLICKED = 'sfh_metal_type_filter_clicked';
export const SFH_SEARCH_ICON_CLICKED = 'sfh_search_icon_clicked';
export const SFH_WEIGHT_DROPDOWN_EXPANDED = 'sfh_weight_dropdown_expanded';
export const SFH_WEIGHT_DROPDOWN_APPLY_CLICKED =
  'sfh_weight_dropdown_apply_clicked';
export const SFH_QTY_MANUAL_INPUT = 'sfh_qty_manual_input';
export const SFH_QTY_PLUS_CLICKED = 'sfh_qty_plus_clicked';
export const SFH_QTY_MINUS_CLICKED = 'sfh_qty_minus_clicked';
export const SFH_QTY_LEARN_MORE_CLICKED = 'sfh_qty_learn_more_clicked';
export const SFH_VALUE_LIMIT_BREACHED = 'sfh_value_limit_breached';
export const SFH_WEIGHT_LIMIT_BREACHED = 'sfh_weight_limit_breached';
export const SFH_CHANGE_CC_CLICKED = 'sfh_change_cc_clicked';
export const SFH_ADD_CC_CLICKED = 'sfh_add_cc_clicked';
export const SFH_CONTINUE_TO_SHIPPING_CLICKED =
  'sfh_continue_to_shipping_clicked';
export const SFH_CONTINUE_TO_REVIEW_CLICKED = 'sfh_continue_to_review_clicked';
export const SFH_NO_NEARBY_SHIP_CENTERS = 'sfh_no_nearby_ship_centers';
export const SFH_CABRELLA_ERROR = 'sfh_cabrella_error';
export const SFH_REQUEST_SUBMITTED = 'sfh_request_submitted';
export const SFH_VIEW_ORDER_CLICKED = 'sfh_view_order_clicked';
export const SFH_WHAT_HAPPENS_NEXT_CLICKED = 'sfh_what_heppens_next_clicked';
export const SFH_VIEW_HISTORY_CLICKED = 'sfh_view_history_clicked';
export const SFH_PACKING_SLIP_DOWNLOADED = 'sfh_packing_slip_downloaded';
export const SFH_SHIPPING_LABEL_DOWNLOADED = 'sfh_shipping_label_downloaded';
export const SFH_TX_DETAILS_CLOSE_CLICKED = 'sfh_tx_details_close_clicked';
export const SFH_TX_DETAILS_OPENED = 'sfh_tx_details_opened';
export const SFH_USER_CANCEL_INITIATED = 'sfh_user_cancel_initiated';
export const SFH_USER_CANCEL_CONFIRMED = 'sfh_user_cancel_confirmed';
export const SFH_BASIC_ACCOUNT_INITIATED = 'sfh_basic_account_initiated';
export const SFH_VERIFY_ACCOUNT_CLICKED = 'sfh_verify_account_clicked';
export const SFH_VERIFY_ACCOUNT_DEFERRED = 'sfh_verify_account_deferred';
export const SFH_NON_PRIMARY_INITIATED = 'sfh_non_primary_initiated';
export const SFH_IRA_UTMA_INITIATED = 'sfh_ira_utma_initiated';
export const SFH_NON_US_INITIATED = 'sfh_non_us_initiated';
export const SFH_ERR_RA_INITIATED = 'sfh_err_ra_initiated';
export const SFH_TC_AGREED = 'sfh_t&c_agreed';
export const SFH_DESC_I_CLICKED = 'sfh_desc_i_clicked';
export const SFH_DESC_DRAWER_BACK_CLICKED = 'sfh_desc_drawer_back_clicked';
export const SFH_DESC_DRAWER_CONTINUE_CLICKED =
  'sfh_desc_drawer_continue_clicked';
